export default "__VITE_ASSET__zIxe$rnP__"